const NAMESPACE = {
  PREFIX: 'mdc' as const,
  SEPARATOR: '-' as const,
};

const CONSTANTS = {
  NAMESPACE,
};

export default CONSTANTS;
